
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.766 20.766"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10.432","cy":"15.771","r":"2.426"}}),_c('path',{attrs:{"d":"M16.23 9.926c-.036-.037-.074-.07-.111-.104l-.109-.103c-.018-.019-.038-.033-.061-.051a7.914 7.914 0 00-10.932.257l-.351.352-.486.486a1.522 1.522 0 00.004 2.15 1.52 1.52 0 002.15.004l.838-.838a4.89 4.89 0 016.904-.001l.605.586a1.508 1.508 0 002.131-.005 1.5 1.5 0 00.443-1.066 1.483 1.483 0 00-.439-1.063l-.586-.604z"}}),_c('path',{attrs:{"d":"M20.363 6.927l-.504-.504c-.002-.002-.003-.005-.007-.006l-.398-.4a1.435 1.435 0 00-.226-.181c-5.113-4.489-12.89-4.351-17.84.411-.024.022-.051.037-.075.061l-.91.911a1.384 1.384 0 00.006 1.959 1.384 1.384 0 001.959.005l.91-.909c.006-.008.011-.015.017-.02 4.003-3.867 10.353-3.891 14.388-.079l.716.717a1.387 1.387 0 001.96-.005 1.388 1.388 0 00.004-1.96z"}})])
          )
        }
      }
    